import { Component, inject } from "@angular/core";
import { PublicFlowChartComponent } from "./public-flow-chart/public-flow-chart.component";
import { CommonModule } from "@angular/common";
import { ValidatedTicketsTableComponent } from "./validated-tickets-table/validated-tickets-table.component";
import { switchMap } from "rxjs";
import { EventsManagementService } from "../../../../services/events-management.service";
import { getParams } from "../../../../../utils/utils";

@Component({
    selector: "app-validated-reports-section",
    imports: [
        CommonModule,
        PublicFlowChartComponent,
        ValidatedTicketsTableComponent,
    ],
    templateUrl: "./validated-reports-section.component.html",
    styleUrl: "./validated-reports-section.component.scss"
})
export class ValidatedReportsSectionComponent {
  private readonly _eventsService = inject(EventsManagementService);

  ticketsByCategory$ = getParams("id").pipe(
    switchMap((idSociedade) =>
      this._eventsService.getTicketsByCategorySummary(idSociedade),
    ),
  );

  validatedTikcets$ = getParams("id").pipe(
    switchMap((idSociedade) =>
      this._eventsService.getValidatedTicketsBySector(idSociedade),
    ),
  );

  publicFlow$ = getParams("id").pipe(
    switchMap((idSociedade) =>
      this._eventsService.getEventsScanByTime(idSociedade),
    ),
  );
}
